// src/store/tags.ts
export const API_EVENT_TAGS = {
  //EVENTS
  ORGANIZER_EVENTS: 'organizer_events',
  ORGANIZER_EVENTS_BY_ID: 'organizer_events_by_id',
  ORGANIZER_EVENTS_INVITATIONS: 'organizer_events_invitations',

  //AUDIENCES
  ORGANIZER_AUDIENCES: 'organizer_audiences',
  // ORGANIZER_AUDIENCE_BY_ID: 'organizer_audience_by_id',
  ORGANIZER_AUDIENCE_CATALOG: 'organizer_audience_catalog',
  ORGANIZER_AUDIENCE_SEGMENTS: 'organizer_audience_segments',
  ORGANIZER_CONTACT_SOURCES: 'organizer_contact_sources',
  ORGANIZER_INTEGRATIONS: 'organizer_integrations',

  //EVENTS_SETUP_TRACK
  EVENTS_SETUP_TRACK: 'events_setup_track',

  //EVENTS_SETUP_PROGRESS
  EVENTS_SETUP_PROGRESS: 'events_setup_progress',

  //BILLING
  ORGANIZER_BILLING: 'organizer_billing',
  ORGANIZER_POST_BILLING: 'organizer_post_billing',
  ORGANIZER_UPDATE_BILLING_BY_ID: 'organizer_update_billing_by_id',

  //CAMPAIGNS
  ORGANIZER_CAMPAIGNS: 'organizer_campaigns',

  //CREDENTIALS
  ORGANIZER_CREDENTIALS: 'organizer_credentials',

  //LANDINGS
  ORGANIZER_LANDINGS: 'organizer_landings',

  //PARTNERS
  ORGANIZER_PARTNERS: 'organizer_partners',

  //CREATIVES
  ORGANIZER_CREATIVES: 'organizer_creatives',
  PARTNER_CREATIVES_DESK: 'partner_creatives_desk',
} as const;

export const AI_ASSISTENCE_TAGS = {
  AI_ASSISTENCE: 'ai_assistence',
} as const;

export const AI_AGENT_TAGS = {
  AI_AGENT: 'ai_agent',
} as const;
export const LANDINGS_TAGS = {
  LANDINGS_PAGES: 'landings_pages',
} as const;
export const USER_TAGS = {
  USER: 'user',
} as const;

export const SUBSCRIPTION_TAGS = {
  SUBSCRIPTION: 'subscription',
} as const;

export const FOLLOW_REPORTS_TAGS = {
  FOLLOW_REPORTS: 'follow_reports',
  FOLLOW_REPORT_SCHEDULES: 'follow_report_schedules',
} as const;

export const PASSKEYS_TAGS = {
  PASSKEYS: 'passkeys',
} as const;

export const ORGANIZATION_INVITES_TAGS = {
  ORGANIZATION_INVITES: 'organization_invites',
} as const;

export const ATTENDEE_TAGS = {
  ATTENDEE_EVENTS: 'attendee_events',
  ATTENDEE_FAVORITES: 'attendee_favorites',
} as const;

export const ONBOARDING_TAGS = {
  ONBOARDING: 'onboarding',
} as const;

export const PRESENTATION_TAGS = {
  PRESENTATION: 'presentation',

  //PRODUCT ANALYTICS
  PRODUCT_ANALYTICS: 'product_analytics',
} as const;

export const BRIEFS_TAGS = {
  PARTNER_BRIEFS: 'partner_briefs',
} as const;

export const TOPICS_TAGS = {
  PARTNER_TOPICS: 'partner_topics',
} as const;

export const LEAD_MAGNETS_TAGS = {
  PARTNER_LEAD_MAGNETS: 'partner_lead_magnets',
} as const;

export const MEETINGS_TAGS = {
  PARTNER_MEETINGS: 'partner_meetings',
} as const;

export const MENTIONS_TAGS = {
  PARTNER_MENTIONS: 'partner_mentions',
} as const;

export const ADMIN_TAGS = {
  ADMIN_USERS: 'admin_users',
  ADMIN_ORGANIZATIONS: 'admin_organizations',
  ADMIN_EVENTS: 'admin_events',
  ADMIN_CAMPAIGNS: 'admin_campaigns',
  ADMIN_CREATIVES: 'admin_creatives',
  ADMIN_LANDINGS: 'admin_landings',
  ADMIN_BILLINGS: 'admin_billings',
  ADMIN_TRANSACTIONS: 'admin_transactions',
  ADMIN_SUBSCRIPTIONS: 'admin_subscriptions',
  ADMIN_WIRE_TRANSFERS: 'admin_wire_transfers',
  ADMIN_WIRE_INVOICES: 'admin_wire_invoices',
  ADMIN_CREDENTIALS: 'admin_credentials',
  ADMIN_ADMINS: 'admin_admins',
  ADMIN_ACTIVITY_LOGS: 'admin_activity_logs',
  ADMIN_WITHDRAWALS: 'admin_withdrawals',
  ADMIN_INVITES: 'admin_invites',
  ADMIN_USER_INVITES: 'admin_user_invites',
  ADMIN_SEGMENTS: 'admin_segments',
  ADMIN_INTEGRATION_LISTS: 'admin_integration_lists',
  ADMIN_CSV_SOURCES: 'admin_csv_sources',
  ADMIN_CREATIVE_TEMPLATES: 'admin_creative_templates',
  ADMIN_LANDING_TEMPLATES: 'admin_landing_templates',
  ADMIN_TERMS: 'admin_terms',
  ADMIN_MCP_TOKENS: 'admin_mcp_tokens',
} as const;
